import React, { Fragment, useEffect, useState,forwardRef, useImperativeHandle } from 'react';
import Switch from "react-switch";
import { useForm, Controller } from "react-hook-form";
import { connect } from "react-redux";
import { Form, Row, Col, Label, Input, Container, Button, FormGroup, InputGroup, ModalBody, Modal, ModalHeader,Collapse } from "reactstrap";
import {
    setAppCustomTitle
} from "../../reducers/ThemeOptions";
import PopOverItem from "../../Common/PopOverItem"
import Loading from '../../Common/Loading';
import { checkIsAdmin, getSessionValue, parseJSON, loadContactFormDetails, getPermissions, getDarkThemeColor,decodeUnicodeEmoji,handleAudioOperation, getCopsPickListItems, removeEmojis, isMobile, checkIsAgencyView } from '../../Common/Appcommon';
import { useAppContext } from "../../Context/AppContext";
import CratioMention from '../Common/CratioFields/CratioMention';
import Select, { components } from "react-select";
import Tabs from "react-responsive-tabs";
import AgentActions from './AgentActions';
import { backgroundSoundOptions, providerHideFields,getAgentFields,showSettingsMinFields,showAgencySettingsHideFields } from './constants';
import NumericInput from 'react-numeric-input';
import IOMapping from '../../Common/IOMapping';
import WebWidgetsMapping from './WebWidgetsMapping';
import cx from "classnames";

const AgentMainContent = forwardRef((props, ref) => {
    const { rowData: initialRowData, fieldNames, voiceList, isLoading, allowNewConfig, selectedVoice, providerName, customActionsEnabled, webhooksEnabled, knowledgeBase, resetToAgentDetail,showAgentProfileSettings,showAgentRoleSettings,showAgentActionSettings,showAgentKnowledgeBase,showAgentDeploy,isCallReady,isCallLoading} = props;
    const { handleSubmit, control, reset, formState: { errors } ,trigger} = useForm({});
    const [showSecret, setShowSecret] = useState(true);
    let isAllowEdit = getSessionValue('isAllowEditAgent') === true || getSessionValue('isAllowEditAgent') === "true" ? true : false;
    const [isAdmin,setAdmin] = useState(true);
    const [selectedMacro, setSelectedMacro] = useState([]);
    const [knowledge, setKnowledge] = useState(showAgentKnowledgeBase);
    const [isSelectChange,setIsSelectChange] = useState(false);
    const [isBtnModal,setIsBtnModal] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const [audioStates,setAudioStates] = useState({isPlaying:false,audio:null});
    const { voiceAgList } = useAppContext();
    const isAgencyView = checkIsAgencyView();
    const [isCollapsed, setCollapsed] = useState({
        "speechSettings": true,//!showSettingsMinFields.includes("speechSettings") ? true : false,
        "callSettings" :  !showSettingsMinFields.includes("callSettings") ? true :false,
        "agentSettings": !showSettingsMinFields.includes("agentSettings") ? true : false,
        "agentInfoFields" : !showSettingsMinFields.includes("agentInfoFields") ? true : false,
        "transcriptionFields" : !showSettingsMinFields.includes("transcriptionFields") ? true : false,
    });

    const [selectedOption, setSelectedOption] = useState({
        "knowledgebase": null,
        "play_background_sound" : null,
        "idle_message": null,
        "language": null,
        "user_input_termination_key_count" : null,
        "Call_Start_Message" : null,
        "vapi_model_name" : null,
        "vapi_modal_provider" : null,
        "model_name" : null,
    });
    //const [draggingSlider, setDraggingSlider] = useState(null); is user for slider drag then show value in popup 
    const [fileTypeValues,setFileTypeValues] = useState({
        "knowledgebase": initialRowData?.[fieldNames["knowledgebase"]] ?? "",
    });

    const speechSettingsRow = parseJSON(initialRowData["speechSettingsFields"]);
    const callSettingsRow = parseJSON(initialRowData["callSettingsFields"]);
    const agencySettingsRow = parseJSON(initialRowData["agencySettingsFields"]);    
    
    const [voiceMailRadio, setVoiceMailRadio] = useState({
        "voice_leave": false,
        "voice_hang" : true,
    });

    const [transcriptionRadio, setTranscriptionRadio] = useState({
        "transcription_speed": true,
        "transcription_accuracy" : false,
    });

    const [deNoicingRadio, setDeNoicingRadio] = useState({
        "remove_noise_back_speech": true,
        "remove_noise" : false,
    });

    const [pronounData,setPronounData] =  useState({
        "word": "",
        "alphabet" : "",
        "phoneme" : "",
    });
    const [phoneNumberDetails, setPhoneNumberDetails] = useState({
        incomingSelected: [],
        outgoingSelected: []
    });
    const [webWidgetsMapping, setWebWidgetsMapping] = useState([]);
    const [pickListItems,setPickListItems] = useState([]);
    const filedsList = getAgentFields(fieldNames, isAllowEdit,providerName,knowledgeBase,selectedOption?.["vapi_modal_provider"]?.["value"],pickListItems);
    useImperativeHandle(ref, () => ({
        triggerSubmit() {
            handleSubmit(onSubmit)();
        }
    }));

    const voiceId = initialRowData[fieldNames["voice_id"]];
    const fvoice = voiceList.flat().find(voice => voice.Voice_Id === voiceId);
    const [voice,setVoice] = useState(fvoice);
    const name = voice ? voice.Name : '';
    const {theme} = useAppContext();
    let isAllowVoiceField = getSessionValue('isAllowVoiceField') === true || getSessionValue('isAllowVoiceField') === "true" ? true : false;
    let isSubAccountView = getSessionValue("isSubAccountView");
    const commonCallFields = filedsList?.callSettingsFields?.common || [];
    const commonSpeechFields = filedsList?.speechSettingsFields?.common || [];
    const callSettingsProFields = filedsList?.callSettingsFields?.[providerName] || [];
    const speechSettingsProFields = filedsList?.speechSettingsFields?.[providerName] || [];
    const allCallSettingsFields = [...commonCallFields, ...callSettingsProFields];
    const allspeechSettingsFields = [...commonSpeechFields, ...speechSettingsProFields];
    const transcriptionSettingsFields = filedsList?.transcriptionSettingsFields?.[providerName] || [];

    const showTxt = false;
    
    useEffect(() => {
        const fetchData = async () => {
            reset(initialRowData);
            let formdetails = await loadContactFormDetails("system_prompt");
            setSelectedMacro(formdetails[0])
            let adminProfile = await checkIsAdmin();
            setAdmin(adminProfile);
            // let knowledge = await getPermissions();
            // if(knowledge.issuccess){
            //     let allow = true;
            //     if(knowledge.data && knowledge.data.length > 0){
            //         knowledge = parseJSON(knowledge.data);
            //         allow = knowledge?.['kb_allowed'] !== undefined ? knowledge?.['kb_allowed'] : true;
            //     }
            //     setKnowledge(allow);
            // }
            let knBase = initialRowData?.[fieldNames["knowledgebase"]] ?? "";
            if(typeof knBase === "string" && knBase !== ""){
                knBase = parseJSON(initialRowData?.[fieldNames["knowledgebase"]]) ?? null;
            }
            let langData = initialRowData?.[fieldNames["language"]] ?? "";
            if(typeof langData === "string" && langData !== ""){
                langData = parseJSON(initialRowData?.[fieldNames["language"]]) ?? null;
                if (langData && langData.label) {
                    langData.label = await decodeUnicodeEmoji(langData.label);
                }
            }

            let pickNameList = ["Agent_Master_Model_Provider_"+providerName,"Agent_Master_Model_Provider_New","Agent_Master_Transcription_Model","Agent_Master_Transcription_Provider","Voice_Master_Accent","Voice_Master_Gender","Voice_Master_Provider","Agent_Master_Language"];   
            let pickList = await getCopsPickListItems(pickNameList);
            if(pickList.issuccess){
                pickList = pickList.data;
            }else {
                pickList = [];
            }
            setPickListItems(pickList);
            setSelectedOption((prevValues) => ({
                ...prevValues,
                knowledgebase: knBase,
                language:langData

            }));
            // let selectedfields = await getFieldsByFormname(formname, "crm_template_operation");
        };
    
        fetchData();
    }, []); // Ensure dependencies are correctly handled
    
    useEffect(() => {

    },[pickListItems])
    
    const isDark = theme === 'dark-theme'? true : false;
    /* const actionInfoFields = [
        {
            label: "AI Agent Name",
            name: "Agent Name",
            datalabel: fieldNames['Agent_Name'],
            type: "text",
            description: "",
            placeholder: "Name Here",
            required: true,
            isDisabled: !isAllowEdit,
        },
        {
            label: "Voice",
            name: "Voice",
            datalabel: fieldNames['voice_id'],
            type: "text",
            description: "Voice.",
            placeholder: "Choose a voice",
            required: false,
            isDisabled: !isAllowEdit,
            autoComplete :"off"
        },
    ]

    const agentTabs = [
        {
            name :"Profile",
            id : "profile"
        },
        {
            name :"Role",
            id : "role"
        },
        {
            name :"Actions",
            id : "action"
        },
    ]; */
    useEffect(() => {
        // Reset initial row data
        const handleEffects = async () => {
            reset(initialRowData);
            let idleMessages = speechSettingsRow?.["idle_message"] ?? [] ;
            if (typeof idleMessages === "string" && idleMessages != "") {
                idleMessages = idleMessages.split(",").map(msg => {
                    const trimmedMsg = msg.trim();
                    return { value: trimmedMsg, label: trimmedMsg };
                });
            }
            let backgroundOption =  speechSettingsRow?.["play_background_sound"];
            if(typeof backgroundOption === "string"){
                const parsed = parseJSON(backgroundOption);
                if (Array.isArray(parsed)) {
                    backgroundOption = parsed[0]
                        ? { value: parsed[0], label: parsed[0] }
                        : null;
                } else {
                    backgroundOption = { value: backgroundOption, label: backgroundOption };
                }
            }
            let langOptions =  initialRowData?.[fieldNames["language"]];
            if(typeof langOptions === "string"){
                langOptions = parseJSON(initialRowData?.[fieldNames["language"]] ?? "") || [];
                if(typeof langOptions !== "object"){
                    langOptions = langOptions[0] 
                    ? { value: langOptions[0], label: langOptions[0] } 
                    : null;
                }
                if (langOptions && langOptions.label) {
                    langOptions.label = await decodeUnicodeEmoji(langOptions.label);
                }
            }

            let firstMsg = initialRowData?.[fieldNames["Call_Start_Message"]];
            if(typeof firstMsg === "string" && providerName == "retell"){
                firstMsg = parseJSON(firstMsg);
                if(typeof firstMsg === "string"){
                    firstMsg = parseJSON(firstMsg);
                }
            }
            let termination_count = callSettingsRow?.["user_input_termination_key_count"];
            if(typeof termination_count === "string"){
                const parsedtermination_count = parseJSON(termination_count);
                if (Array.isArray(parsedtermination_count)) {
                    termination_count = parsedtermination_count[0]
                        ? { value: parsedtermination_count[0], label: parsedtermination_count[0] }
                        : null;
                } else {
                    termination_count = { value: termination_count, label: termination_count };
                }
            }

            let model_name = agencySettingsRow?.["model_name"];
            if(typeof model_name === "string"){
                let parsed = parseJSON(model_name);
                if (Array.isArray(parsed)) {
                    model_name = parsed[0]
                        ? { value: parsed[0], label: parsed[0] }
                        : null;
                } else if(parsed && parsed.value && parsed.label){
                    model_name = parsed;
                }else {
                    model_name =  { value: model_name, label: model_name };
                }
            }else {
                model_name = getParsedData(agencySettingsRow?.["model_name"])
            }
            let knBase = initialRowData?.[fieldNames["knowledgebase"]] ?? "";
            if(typeof knBase === "string" && knBase !== ""){
                knBase = parseJSON(initialRowData?.[fieldNames["knowledgebase"]]) ?? null;
            }
            setSelectedOption((prevValues) => ({
                ...prevValues,
                idle_message: idleMessages, // Array for multi-select
                play_background_sound: backgroundOption, // Object for single select
                language:langOptions,
                user_input_termination_key_count : termination_count,
                Call_Start_Message : firstMsg ,
                vapi_model_name : !isSelectChange ? getParsedData(agencySettingsRow?.["vapi_model_name"]) : null,
                vapi_modal_provider : getParsedData(agencySettingsRow?.["vapi_modal_provider"]),
                model_name : model_name,
                knowledgebase:knBase
            }));

            let pronunciationData = speechSettingsRow?.["pronunciation"];
            setPronounData((prevValues) => ({
                ...prevValues,
                "word": pronunciationData?.["word"] ?? pronunciationData?.["pronoun_word"] ?? "",
                "alphabet" : pronunciationData?.["alphabet"] ?? pronunciationData?.["pronunciation_txt"] ?? null,
                "phoneme" : pronunciationData?.["phoneme"] ?? "",
            }));

            let transMode =  speechSettingsRow?.["transcription_mode"] ?? "fast";
            let transName = transMode == "accurate" ? "transcription_accuracy" : "transcription_speed";
            let opposite = transName == "transcription_speed" ? "transcription_accuracy" : "transcription_speed";
            setTranscriptionRadio({
                [transName]: true,
                [opposite]: false,
            });
            
            let denoiceMode =  speechSettingsRow?.["denoicing_mode"] ?? "noise-cancellation";
            let denoiceName = denoiceMode == "noise-cancellation" ? "remove_noise" : "remove_noise_back_speech";
            let denoiceOpposite = denoiceName == "remove_noise_back_speech" ? "remove_noise" : "remove_noise_back_speech";
            setDeNoicingRadio({
                [denoiceName]: true,
                [denoiceOpposite]: false,
            });
        }
        handleEffects();
    }, [initialRowData, reset, fieldNames]);

    useEffect(()=>{
        setCollapsed((prevValues) => ({
            ...prevValues,
            "speechSettings": true,//!showSettingsMinFields.includes("speechSettings") ? true : false,
            "callSettings" :  !showSettingsMinFields.includes("callSettings") ? true :false,
            "agentSettings": !showSettingsMinFields.includes("agentSettings") ? true : false,
            "agentInfoFields" : !showSettingsMinFields.includes("agentInfoFields") ? true : false,
        }));
        let voiceId = selectedVoice;
        let voice = voiceList.flat().find(voice => voice["Voice_Id"] === voiceId);
        setVoice(voice);
        let agData = voiceAgList[0];
        if(!!voice && agData){
            agData.forEach(agVoice => {
                if(agVoice['table_280_id'] === voice['table_280_id']) {
                    setVoice(voice);
                }
            });
        }
        
    },[selectedVoice])

    const handleFileUpload = async (event,field) => {
        const fileUploaded = event.target.files[0];
        if (!fileUploaded) {
          console.error("No file selected.");
          return;
        }
        const fileName = fileUploaded.name;
        field.onChange(fileName);
        // setFileTypeValues((prevValues) => ({
        //     ...prevValues,
        //     [name]: fileName,
        // }));    
        // Prepare the FormData
        const formData = new FormData();
        formData.append("file", fileUploaded); // 'file' matches the expected field in the API
        try {
            const response = await fetch("https://api.vapi.ai/file", {
            method: "POST",
            headers: {
                "Authorization": "Bearer 9b2b38fe-7c17-4ec6-85e3-7a13b377747d", // Replace with your actual API key
            },
            body: formData,
        });
        if (response.ok) {
            //const body = await response.json();
        } else {
            console.error("Error response:", response.status, await response.text());
        }
        } catch (error) {
            console.error("Upload failed:", error);
        }
    };

    const getParsedData = (options) =>{
        if(typeof options === "string"){
            let optionsMgs = parseJSON( options ?? "") || [];
            options = optionsMgs[0] 
                ? { value: optionsMgs[0], label: optionsMgs[0] } 
            : null;
        }
        return options;
    }
    const onSubmit = async (data) => {
        const isValid = await trigger();
        if (!isValid) {
            return;
        }
        let  Tabs = [
            filedsList.configViewFieldSave, 
            filedsList.roleTabFields, 
            filedsList.advancedSettingsFields,
            filedsList.speechSettingsFields?.[providerName], 
            filedsList.callSettingsFields?.[providerName]
        ];
        let stateVariable = {
            dropdown: selectedOption,
        };
        Tabs.forEach((tab) => {
            tab.forEach((field) => {
                if (typeof stateVariable[field.type] === 'string') {
                    if(data[field.name]){
                        data[field.name] = stateVariable[field.type][field.name];
                    }
                }
            });
        });
        data['voice_id'] =voice?.Voice_Id;
        data['play_background_sound'] = selectedOption.play_background_sound;
        data['phoneNumberDetails'] = phoneNumberDetails;
        data['webWidgetsDetails'] = webWidgetsMapping;
        props.onSubmit(data);
    };

    const handleChange = (e,field, type = "",pField = "") => {
        let {name, value} = e.target;
        if(name === "remainder_msg_frequency_seconds" || name === "remainder_msg_frequency_seconds_times"){
            if (value === "0" || parseInt(value) < 1 || value === "") {
                value = 1; // set the corrected value
              }
        }
        if(type === "adv_settings"){
            let adv_settings = {...parseJSON(initialRowData["advanced settings"]) };
            adv_settings[name] = value;
            props.onChange("advanced settings", JSON.stringify(adv_settings));
        }else{
            //name = fieldNames[name] ?? name;
            let isSubField = false;
            if(pField !== ""){
                name = `${pField},${name}`;
                isSubField = true;
            }else{
                if(["Agent Name","Call Start Message"].includes(name)){

                }else {
                    name = fieldNames[name];
                }
            }
            props.onChange(name, value,isSubField)
        }
    };

    const handleNeumericChange = (val,name,type = "",pField = "") => {
        let isSubField = false;
        if(pField !== ""){
            name = `${pField},${name}`;
            isSubField = true;
        }
        props.onChange(name, val,isSubField)
    };

    const openModel = (e) => {
        props.modalOpen(voice);
    };

    const handleOnChange = (e,field) => {
        if(field === "mention"){
            let {name, value} = e.target;
            value = value.replaceAll("$$", "").replaceAll("&nbsp;", " ");
            props.onChange(name, value);
        }else{
            props.onChange(e, field);
        }
    }


    const handleOnChangeMention = (e,field, type = "",pField = "") => {
        let {name, value} = e.target;
        value = value.replaceAll("$$", "").replaceAll("&nbsp;", " ");
        let isSubField = false;
        if(pField !== ""){
            name = `${pField},${name}`;
            isSubField = true;
        }else{
            if(["Agent Name","Call Start Message"].includes(name)){

            }else {
                name = fieldNames[name];
            }
        }
        props.onChange(name, value,isSubField);
    }
    const handleSliderChange = (e,field,name,pField = "") => {
        const newValue = e.target.value;
        field.onChange(newValue);
        //value = newValue;
        let isSubField = false;
        if(pField !== ""){
            name = `${pField},${name}`;
            isSubField = true;
        }
        //name = fieldNames[name] ?? name;
        props.onChange(name, newValue,isSubField);
    };

    const handleSliderDragStart = (name) => {
        //setDraggingSlider(name); // Set the currently dragged slider
    };

    const handleSliderDragEnd = () => {
        setTimeout(() => {
            //setDraggingSlider(null);
        }, 1000);
    };

    const handleBtnModal = () => {
        setIsBtnModal(!isBtnModal);
    }
    const toggleBtnModal = () => {
        handleBtnModal();
    }

    const handleBtnModalCancel = () =>{
        setEditIndex(null);
        handleBtnModal();
    }
    const onpronounSelectChange = (name,option,field) =>{
        setPronounData((prevValues) => ({
            ...prevValues,
            [name]: option,
        }));
    }
    const getBtnModal = () => {
        return (
            <div>
                <Modal isOpen={isBtnModal} className='' centered>
                    <ModalHeader toggle={e => toggleBtnModal()}>
                        <span className='ps-2'>
                            Pronunciation
                        </span>
                    </ModalHeader>
                    <ModalBody>
                        <div className='ms-auto ps-3 pe-3'>
                            {filedsList.pronunciationFields && filedsList.pronunciationFields.length > 0 && filedsList.pronunciationFields.map((field, index) => {
                                const { label, name, datalabel, type, placeholder, required, description, isDisabled, autoComplete, min, max, step, marks, options, allowMulti } = field;
                                return (
                                    <Col md="12" lg="12" className='mb-3' key={index}>
                                        <Label className="d-flex align-items-center fv-normal label" htmlFor={name}>
                                            {label}
                                            {false && description && (
                                                <PopOverItem
                                                    id={index + "-call"}
                                                    body={description}
                                                    theme={isDark}
                                                />
                                            )}
                                        </Label>
                                        <Controller
                                            name={name}
                                            control={control}
                                            rules={{
                                                required:
                                                required && ["text", "mension", "textarea"].includes(type) && !pronounData[name] ? `${label} is required`
                                                : false,
                                            }}
                                            render={({ field }) => {
                                                if (type !== "slider" && type !== "switch" && type !== "dropdown") {
                                                    return(
                                                        <Input
                                                            {...field}
                                                            type={type}
                                                            placeholder={placeholder}
                                                            value={
                                                                pronounData[name] ?? ""
                                                            }
                                                            className={`${errors[name] ? 'is-invalid' : (["Call Start Message","Call_End_Message"].includes(name) ? "agent-greeting" : '')} ${name === "Voice" ? "cursor-pointer" : ''}`}
                                                            onChange={e => pronounhandleChange(e,field)}
                                                            onClick={name === "Voice" ? e => openModel(e) : undefined}
                                                            disabled={isDisabled}
                                                            autoComplete={autoComplete}
                                                        />
                                                    )
                                                }else if (type === "dropdown"){
                                                    return(
                                                        <Select
                                                            name={name}
                                                            id={name}
                                                            className="basic-select"
                                                            classNamePrefix="sub-select wa-select"
                                                            value={pronounData?.[name] ? pronounData[name] : options[0]}
                                                            onChange={e => onpronounSelectChange(name,e,field)}
                                                            options={options}
                                                            isMulti={allowMulti}
                                                        />
                                                    )
                                                }
                                            }}
                                        />
                                        {errors[name] && (
                                            <em className="text-danger">
                                                {errors[name].message}
                                            </em>
                                        )}
                                    </Col>
                                );
                            })}
                            <div className='d-flex gap-2'>
                                <Button className="ms-auto mb-2 btn-icon submit-btn btn-background" onClick={e => handleBtnModalCancel()}>
                                    Cancel
                                </Button>
                                <Button className="mb-2 btn-icon submit-btn btn-background" onClick={e => handlePronounceSubmit()}>
                                    Save {/* {editIndex !== null ? "Edit" : "Add" } */}
                                </Button>
                            </div>
                            
                        </div>
                    </ModalBody>
                </Modal>
            </div>
        );
    }

    const formatDuration = (seconds) => {
        if (seconds < 60) {
          return `${seconds}`;
        }
        const minutes = seconds / 60;
        if (minutes < 60) {
          return `${minutes.toFixed(1)} m`;
        }
        
        const formattedTime = ((seconds / 60) / 60).toFixed(2) + ' h';
        return formattedTime;

        const totalMinutes = seconds / 60;
        const hours = Math.floor(totalMinutes / 60);
        const remainingMinutes = (totalMinutes % 60).toFixed(0);
      
        return `${hours}.${remainingMinutes} h`;
    }

    const sliderButton = (name = "", marks, min, max, step,fvalue,field,isTopRemove = false,rowFieldName = "",rowFields = []) => {
        let value = rowFields?.[name] ?? fvalue; // Get the current slider value
        value = parseFloat(value);
        let formattedTime = formatDuration(value);
        return (
            <div className={`${isTopRemove ? '' : 'slider-container'}`} style={{ position: "relative" }}>
                {/* Tooltip for the currently dragged slider */}
                {/* {draggingSlider === name ? (
                    <span
                        className={`tooltip slider-tooltip `}
                        style={{
                            position: "absolute",
                            left: `${((value - min) / (max - min)) * 100}%`,
                            transform: "translateX(-50%)", // Center tooltip
                            whiteSpace: "nowrap",
                        }}
                    >
                        {value}
                    </span>
                ) : null} */}

                {/* Slider input */}
                <div className='d-flex gap-4 align-items-center'>
                    <input
                        name={name}
                        type="range"
                        min={min}
                        max={max}
                        step={step}
                        value={value}
                        className="custom-slider w-75"
                        onChange={e => handleSliderChange(e,field,name,rowFieldName)}
                        onMouseDown={e => handleSliderDragStart(name)}
                        onMouseUp={e => handleSliderDragEnd}
                        onTouchStart={e => handleSliderDragStart(name)}
                        onTouchEnd={e => handleSliderDragEnd}
                        // isDisabled = {disabled}
                        style={{
                            background: `linear-gradient(to right, var(--theme-main) 0%, var(--theme-main) ${
                                ((value - min) / (max - min)) * 100
                            }%, var(--slider-btn-bg ) ${
                                ((value - min) / (max - min)) * 100
                            }%, var(--slider-btn-bg ) 100%)`,
                        }}
                    />
                    <div className='custom-2-col-md-3 black-color txt-ovrflw rounded-3 fs-6 fw-bold'>
                        {formattedTime}
                        {/* <input
                            name={name}
                            type="text"
                            min={min}
                            max={max}
                            step={step}
                            value={formattedTime}
                            className='desc-text txt-ovrflw w-full text-center slider-txt-box rounded-3'
                        /> */}
                    </div>
                </div>
                
                {/* Dynamic marks */}
                {marks &&
                    <div className="w-82 marks" style={{ display: "flex", justifyContent: "space-between"}}>
                        {Object.entries(marks)
                        .sort((a, b) => parseFloat(a[0]) - parseFloat(b[0])) // 🔥 sort numerically
                        .map(([key, label], index) => (
                            <span key={index} className={index === 1 ? 'agent-section-slider-desc' : ''}>{label}</span>
                        ))
                        }
                    </div>
                }
                
            </div>
        );
    };

    const handleSwitch = (name,newValue,field,pField) =>{
        //const value = switchIsActive[name]; // Get the current slider value
        let fName = name;
        field.onChange(newValue);
        let isSubField = false;
        if(pField !== ""){
            fName = `${pField},${fName}`;
            isSubField = true;
        }
        props.onChange(fName, newValue,isSubField)
    }

    const onSelectChange = (name,option,field,options,pField = "") =>{
        //let op = option ?.length > 0 ? option : {}; 
        let fName = name;
        if(name == "idle_message"){
            let isAll = option.some(item => item.value === "all");
            if(isAll){
                options = options.filter(item => item.value !== "all");
                option = options;
            }
        }
        
        field.onChange(option);
        let isSubField = false;
        if(pField !== ""){
            fName = `${pField},${fName}`;
            isSubField = true;
        }else {
            fName = fieldNames[fName];
        }
        if (name == "vapi_modal_provider") {
            setIsSelectChange(true);
            setSelectedOption((prevValues) => ({
              ...prevValues,
              "vapi_model_name": null, // ✅ Clear model
            }));
        }else {
            setIsSelectChange(false);
        }
        props.onChange(fName, option,isSubField)
        setSelectedOption((prevValues) => ({
            ...prevValues,
            [name]: option,
        })); 
              
    }

    const customFilter = (option, inputValue) => {
        return option.label.toLowerCase().includes(inputValue.toLowerCase()); // Default filtering
    };

    const handleVmailRdoBtn = (name,e,field,fieldName,pField = "") =>{
        var val = e.target.value;
        field.onChange(val);
        let opposite = name === "voice_hang" ? "voice_leave" : "voice_hang";
        if(name === "voice_hang"){
            let fName = `${pField},voicemail_message`;
            props.onChange(fName, "",true)
        }
        if(fieldName == "transcription_mode"){
            opposite = name === "transcription_speed" ? "transcription_accuracy" : "transcription_speed";
            setTranscriptionRadio({
                [name]: true,
                [opposite]: false,
            });

            let isSubField = false;
            if(pField !== ""){
                fieldName = `${pField},${fieldName}`;
                isSubField = true;
            }
            props.onChange(fieldName, val,isSubField)
        }else if(fieldName == "denoicing_mode") {
            opposite = name === "remove_noise_back_speech" ? "remove_noise" : "remove_noise_back_speech";
            setDeNoicingRadio({
                [name]: true,
                [opposite]: false,
            });
            let isSubField = false;
            if(pField !== ""){
                fieldName = `${pField},${fieldName}`;
                isSubField = true;
            }
            props.onChange(fieldName, val,isSubField)
        }else {
            props.onChange("callSettingsFields," + name, true, true);
            props.onChange("callSettingsFields," + opposite, false, true);
            setVoiceMailRadio({
                [name]: true,
                [opposite]: false,
            });
        }
        
    }
    const switchButton = (name,field,pField = "",rowFields = []) =>{
        let isActive = rowFields?.[name]; 
        return(
            <Switch
                height={20} 
                width={40} 
                onColor={getDarkThemeColor()}
                onChange={(e) => handleSwitch(name,!isActive ? true: false,field,pField)} 
                checked={isActive}
                checkedIcon={
                <></>
                }
                uncheckedIcon={
                    <></>
                }
                // isDisabled = {isDisabled}
            />
        )
    }
      
    const roleTab = () =>{
        let mapField = filedsList.roleTabFields;
        return(
            <Container fluid className='p-0'>
                <div className='agent-config-container'>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <div className='agent-config-form'>
                            <Row className="">
                                {mapField && mapField.length > 0 && mapField.map((field, index) => {
                                    const { label, name, datalabel, type, placeholder, required, description, isDisabled,autoComplete ,min,max,step,marks,options,allowMulti,subFields,value} = field;
                                    if(name === "knowledgebase" && !showAgentKnowledgeBase && !isAgencyView){
                                        return;
                                    }
                                    return (
                                        <Col md="12" lg="12" className='mb-3'>
                                            <Label className="d-flex align-items-center label" htmlFor={name}>
                                                {label}
                                                {false && 
                                                    description &&
                                                    <PopOverItem 
                                                        id={index + "role"}
                                                        body={description}
                                                        theme={isDark}
                                                    />
                                                }
                                            </Label>
                                            <Controller
                                                name={name}
                                                control={control}
                                                rules={{
                                                    required:
                                                    required &&
                                                    ["text", "mension", "textarea"].includes(type) && !initialRowData[datalabel] ? `${label} is required`
                                                    : false,
                                                }}
                                                render={({ field }) => {
                                                    if (type !== "slider" && type !== "switch" && type !== "dropdown" && type !== "buttonModal" && type !== "mention") {
                                                        return (
                                                            <Input
                                                                {...field}
                                                                type={type}
                                                                placeholder={placeholder}
                                                                value={
                                                                    name === "Voice"
                                                                    ? voice?.Name || ""
                                                                    : type === "file"
                                                                    ? fileTypeValues[name] // Prevent setting value for file input
                                                                    : initialRowData[datalabel] ?? ""
                                                                }
                                                                className={`${errors[name] ? 'is-invalid' : (name === "Call Start Message" ? "agent-greeting" : '')} ${name === "Voice" ? "cursor-pointer" : ''}`}
                                                                onChange={type !== "file" ? e => handleChange(e,field) : e => handleFileUpload(e,field)}
                                                                onClick={name === "Voice" ? e => openModel(e) : undefined}
                                                                disabled={isDisabled}
                                                                autoComplete={autoComplete}
                                                                options = {options}
                                                            />
                                                        );
                                                    }else if (type === "slider") {
                                                        return (
                                                            sliderButton(name,min,max,marks,step,value,field)
                                                        );
                                                    }else if (type === "switch") {
                                                        return (
                                                            switchButton(name,field)
                                                        );
                                                    }else if (type === "dropdown"){
                                                        return(
                                                            <Select
                                                                name={name}
                                                                id={name}
                                                                className="basic-select"
                                                                classNamePrefix="sub-select wa-select"
                                                                value={Object.keys(selectedOption?.[name] || {}).length > 0 ? selectedOption[name] : options[0]}
                                                                onChange={e => onSelectChange(name,e,field,options)}
                                                                options={options}
                                                                isMulti={allowMulti}
                                                                placeholder = {placeholder}
                                                                styles={{
                                                                    dropdownIndicator: (base) => ({
                                                                      ...base,
                                                                      padding: 2,             // less padding = smaller arrow container
                                                                      fontSize: '12px',       // make icon smaller
                                                                    }),
                                                                }}
                                                            />
                                                        )
                                                    }else if(type === "mention"){
                                                        return(
                                                            <div>
                                                                <CratioMention
                                                                    name={name}
                                                                    inputID={name}
                                                                    value={initialRowData[datalabel]}
                                                                    fieldkey="id"
                                                                    mentionTrigger="$"
                                                                    handleOnChange={handleOnChange}
                                                                    formname="table_74"
                                                                    control={control}
                                                                    customClassName= {`textbox-mention form-control custom-mention-style ${["Call Start Message","Call_End_Message"].includes(name) ? "agent-greeting" : ''}`}
                                                                    customPanelClassName="panel-mention-subject custom-mention-style"
                                                                    placeholder="Enter your agent prompt here"
                                                                    cols={1000}
                                                                    suggestionList={selectedMacro}
                                                                    rows={["Call Start Message","Call_End_Message"].includes(name) ? 3 : 10}
                                                                />
                                                                <p className='d-flex align-items-center form-label deploy-desc'>Note: Use '$' to add contact variables.</p>
                                                            </div>
                                                        )
                                                    }
                                                    return null; // Render nothing if type is neither "text" nor "slider"
                                                }}
                                            />
                                            {((name === "Call_Start_Message" && selectedOption["Call_Start_Message"]?.value == "msg")) && (
                                                <div className='flex flex-col rounded-lg'>
                                                    {constructSubFields(name,subFields,initialRowData)}
                                                </div>
                                            )}
                                        
                                            {errors[name] && (
                                                <em className="text-danger">
                                                    {errors[name].message}
                                                </em>
                                            )}
                                        </Col>
                                    );
                                })}
                            </Row>
                        </div>
                        {isAllowEdit &&
                        <Row className='agent-config-form mb-5 hide'>
                            <Col md="2">
                            <Loading 
                                showLoader={isLoading} 
                                mainContent = {
                                    <Button className="agent-save-btn btn-icon submit-btn btn-background" type="submit">
                                        Save
                                    </Button>}
                            />
                            </Col>
                        </Row>
                        }
                    </Form>
                </div>
            </Container>
        )
    }
    const deployTab = () =>{
        return(
            <Container fluid className='p-0'>
                <div className='agent-config-container'>
                    <div className='pb-1 agent-div-container agent-config-form'>
                        <Row>
                            <Col>
                                <div className={`d-flex gap-2 hide ${showSettingsMinFields.includes("agentInfoFields") ? 'cursor-pointer' : ''} mb-2`} onClick = {e => onHideSubSetting("agentInfoFields")}>
                                    <span className={`agent-header-title w-50 txt-ovrflw profile-headers`}>Deploy Agents</span>
                                </div> 
                            </Col>
                        </Row>
                            {filedsList.callMappings.map(({ type, label,description }) => (
                        <Row>
                                <Col md={10} className='mb-3' key={type}>
                                    <div className='d-flex gap-2'>
                                        <span className='mb-1 agent-header-title fv-normal'>{label}</span>
                                    </div>
                                    <p className='deploy-desc'>{description}</p>
                                    <IOMapping
                                        type={type}
                                        handleOnChange={handlePhoneNumberDetailsChanges}
                                        defaultId={initialRowData?.["table_250_id"]}
                                    />
                                </Col>
                        </Row>

                            ))}
                            {
                       <Col md={10}className='pb-1'>
                            <div className={`d-flex gap-2' ${showSettingsMinFields.includes("agentInfoFields") ? 'cursor-pointer' : ''}`} onClick = {e => onHideSubSetting("agentInfoFields")}>
                                <span className={`mb-1 agent-header-title w-50 txt-ovrflw fv-normal`}>Assign Web Widgets for Web Calling</span>
                            </div>
                            <p className='deploy-desc'>Connect existing web widgets to this agent for live website conversations.</p>
                            <WebWidgetsMapping  handleOnChange = {handleWebWigetDetailsChanges} defaultId ={initialRowData?.["table_250_id"]}/>
                        </Col>
                    }
                    </div>
                    
                </div>
           </Container>
        )
    } 
    const validateFormData = (label,key) => {
        let response = false;
        if(key === undefined || key === null || key === ""){
            response = `${label} is required`;
        }
        return response;
    }
    const constructSubFields = (fieldName,subFields,rowField,rowFieldName = "") =>{
        if(fieldName == "Call_End_Message"){
        }else if(fieldName == "voicemail_detection"){
            subFields = subFields[providerName] ?? [];
        }
        let radioOption = fieldName == "transcription_mode" ? transcriptionRadio : (fieldName == "denoicing_mode" ? deNoicingRadio : voiceMailRadio);
        return(
            <div >
                {subFields && subFields.map((subField, subIndex) => {
                    let { label, name, datalabel, type, placeholder, required, description, isDisabled, autoComplete, marks, min, max, step, options,value,subInFields,allowMulti,tip } = subField;
                    if(type == "textarea"){
                    }
                    isDisabled = name === "voicemail_message" && radioOption["voice_hang"];
                    return (
                        <>
                            <div key={subIndex} className={`${ ["max_voicemail_msg_wait","initial_detection_delay","detection_retry_interval","max_detection_retries","vapi_voicemail_message","voicemail_duration", "backchannel_frequency", "backchannel_words","user_input_timeout","user_input_termination_key","user_input_termination_key_digit_limit"].includes(name) ? 'pt-2' : 'd-flex gap-2'}`}>
                                {type !== "radio" && label && name !== "Call_End_Message" &&
                                <Label className='d-flex'>{label}
                                    { 
                                        tip &&
                                        <PopOverItem 
                                            id={subIndex + fieldName}
                                            body={tip}
                                            theme={isDark}
                                        />
                                    }
                                </Label>}
                                {
                                    description && 
                                    <span className='desc-text agent-btn-icon'>{description}</span>
                                }
                                <div className={ name === "Call_End_Message" ? "pt-2 w-full" : name === "voicemail_message" ? "w-full" : ""}>
                                    <Controller
                                        name={name}
                                        control={control}
                                        rules={{
                                            required:
                                            required && ["text", "mention","textarea"].includes(type) && !rowField[datalabel] && name !== "voicemail_message" ? `${label} is required`
                                            : false,
                                        }} 
                                        render={({ field }) => {
                                            if (type !== "slider" && type !== "switch" && type !== "dropdown" && type !== "radio" && type !== "numericInput" && type != "mention")  {
                                                return (
                                                    <Input
                                                        {...field}
                                                        type={type}
                                                        placeholder={placeholder}
                                                        value={rowField[datalabel] ?? ""}
                                                        className={`${errors[name] ? 'is-invalid agent-greeting' : (["Call Start Message","Call_End_Message","voicemail_message","vapi_voicemail_message"].includes(name) ? 'agent-greeting' : '')}`}
                                                        onChange={e => handleChange(e,field,"",rowFieldName)}
                                                        onClick={name === "Voice" ? e => openModel(e) : undefined}
                                                        disabled={isDisabled}
                                                        autoComplete={autoComplete}
                                                    />
                                                );
                                            } else if (type === "slider") {
                                                return sliderButton(name, marks, min, max, step,value, field,false,rowFieldName,rowField);
                                            } else if (type === "switch") {
                                                return switchButton(name, field,rowFieldName,rowField);
                                            } else if (type === "dropdown") {
                                                return (
                                                    <Select
                                                        name="selected_form"
                                                        id="selected_form"
                                                        className="basic-select text-align-center"
                                                        classNamePrefix="sub-select wa-select"
                                                        value={selectedOption?.[name] ? selectedOption[name] : options[0]}
                                                        onChange={e => onSelectChange(name, e, field,options,rowFieldName)}
                                                        options={options}
                                                        isMulti={allowMulti}
                                                        isClearable={true}
                                                        filterOption={customFilter}
                                                    />
                                                );
                                            }else if (type === "radio") {
                                                return (
                                                    <Input
                                                        {...field}
                                                        type="radio"
                                                        value={value} // <-- pass value from subField
                                                        checked={radioOption?.[name] ?? false }
                                                        disabled={isDisabled}
                                                        className='agent-vmail-detect-bck-clr'
                                                        onChange={e => handleVmailRdoBtn(name,e,field,fieldName,rowFieldName)}
                                                    />
                                                )
                                            }else if(type === "numericInput"){
                                                return(
                                                    <NumericInput mobile className="form-control" min={min} max={max} value={rowField[datalabel] ?? value}
                                                        onChange={e => handleNeumericChange(e,name,"",rowFieldName)}
                                                        style={{
                                                            btnUp: { backgroundColor: 'var(--white-bg)',border: 'none',paddingLeft: "5px" },
                                                            btnDown: { backgroundColor: 'var(--white-bg)',border: 'none' ,paddingLeft: "5px"}
                                                        }}
                                                    />
                                                )
                                                
                                            }if(type === "mention"){
                                                return(
                                                    <div>
                                                        <CratioMention
                                                            name={name}
                                                            inputID={name}
                                                            value={initialRowData[datalabel]}
                                                            fieldkey="id"
                                                            mentionTrigger="$"
                                                            handleOnChange={ e => handleOnChangeMention(e,field,"",rowFieldName)}
                                                            control={control}
                                                            customClassName={`textbox-mention form-control custom-mention-style ${["Call Start Message","Call_End_Message"].includes(name) ? "agent-greeting" : ''}`}
                                                            customPanelClassName="panel-mention-subject custom-mention-style"
                                                            placeholder="Enter your agent prompt here"
                                                            cols={1000}
                                                            suggestionList={selectedMacro}
                                                            rows={["Call Start Message","Call_End_Message"].includes(name) ? 2 : 10}
                                                        />
                                                        <p className='d-flex align-items-center form-label deploy-desc'>Note: Use '$' to add contact variables.</p>
                                                    </div>
                                                )
                                            }
                                            return null;
                                        }}
                                    />
                                </div>
                                {type == "radio" && <Label>{label}</Label>}
                                {subInFields && rowField[name] &&
                                    <div className='flex flex-col rounded-lg agent-vmail-detect-bck-clr agent-vmail-detect-bck-rds'>
                                        {constructSubInFields(name,subInFields,rowField,rowFieldName)}
                                    </div>
                                }
                                
                            </div>
                            {errors[name] && (
                                <em className="text-danger">
                                    {errors[name].message}
                                </em>
                            )}
                        </>
                    );
                })}
            </div>
        )        
    }

    const constructSubInFields = (fieldName,subFields,rowField,rowFieldName = "") =>{
        let radioOption = fieldName == "transcription_mode" ? transcriptionRadio : (fieldName == "denoicing_mode" ? deNoicingRadio : voiceMailRadio);
        return(
            <div >
                {subFields && subFields.map((subField, subIndex) => {
                    let { label, name, datalabel, type, placeholder, required, description, isDisabled, autoComplete, marks, min, max, step, options,value,subInFields,allowMulti,isClear } = subField;
                    isDisabled = name === "voicemail_message" && radioOption["voice_hang"];
                    return (
                        <div key={subIndex} className={`${ ["voicemail_duration", "backchannel_frequency", "backchannel_words"].includes(name) ? 'p-2' : (name === "user_input_termination_key_digit_limit_count" ? 'gap-2 digit-limit' : 'd-flex gap-2')}`}>
                            {type !== "radio" && label && <Label className='d-flex'>{label}</Label>}
                            {
                                description && 
                                <span className='desc-text'>{description}</span>
                            }
                            <Controller
                                name={name}
                                control={control}
                                rules={{
                                    required:
                                      required && ["text", "mension"].includes(type) && !rowField[datalabel]
                                        ? `${label} is required`
                                        : false,
                                }}
                                render={({ field }) => {
                                    if (type !== "slider" && type !== "switch" && type !== "dropdown" && type !== "radio" && type !== "numericInput") {
                                        return (
                                            <Input
                                                {...field}
                                                type={type}
                                                placeholder={placeholder}
                                                value={rowField[datalabel] ?? ""}
                                                className={`${errors[name] ? 'is-invalid' : (name === "Call Start Message" ? "agent-greeting" : '')} ${name === "Voice" ? "cursor-pointer" : ''}`}
                                                onChange={e => handleChange(e,field,"",rowFieldName)}
                                                onClick={name === "Voice" ? e => openModel(e) : undefined}
                                                disabled={isDisabled}
                                                autoComplete={autoComplete}
                                            />
                                        );
                                    } else if (type === "slider") {
                                        return sliderButton(name, marks, min, max, step,value, field,false,rowFieldName,rowField);
                                    } else if (type === "switch") {
                                        return switchButton(name, field,rowFieldName,rowField);
                                    } else if (type === "dropdown") {
                                        return (
                                            <Select
                                                name="selected_form"
                                                id="selected_form"
                                                className="basic-select w-full"
                                                classNamePrefix="sub-select wa-select"
                                                value={selectedOption?.[name] ? selectedOption[name] : options[0]}
                                                onChange={e => onSelectChange(name, e, field,options,rowFieldName)}
                                                options={options}
                                                isMulti={allowMulti}
                                                isClearable={isClear}
                                                filterOption={customFilter}
                                            />
                                        );
                                    }else if (type === "radio") {
                                        return (
                                            <Input
                                                {...field}
                                                type="radio"
                                                value={value} // <-- pass value from subField
                                                checked={radioOption?.[name] ?? false }
                                                disabled={isDisabled}
                                                className='agent-vmail-detect-bck-clr'
                                                onChange={e => handleVmailRdoBtn(name,e,field,fieldName,rowFieldName)}
                                            />
                                        )
                                    }else if(type === "numericInput"){
                                        return(
                                            <NumericInput mobile className="form-control" min={min} max={max} value={rowField[datalabel] ?? value}
                                                onChange={e => handleNeumericChange(e,name,"",rowFieldName)}
                                                style={{
                                                    btnUp: { backgroundColor: 'var(--white-bg)',border: 'none',paddingLeft: "10px" },
                                                    btnDown: { backgroundColor: 'var(--white-bg) !important', border: 'none', paddingLeft: "10px"}
                                                }}
                                            />
                                        )
                                    }
                                    return null;
                                }}
                            />
                            {type == "radio" && <Label>{label}</Label>}
                        </div>
                    );
                })}
            </div>
        )        
    }
    const handlePronounceSubmit = async () => {
        let data = speechSettingsRow?.[["pronunciation"]] || [];
        data = typeof data === "string" ? JSON.parse(data) : data;
        setPronounData((prevValues) => ({
            ...prevValues,
            "alphabet" : pronounData["alphabet"] || { value: "ipa", label: "IPA" },
        }));
        if (editIndex !== null) {
            data[editIndex] = pronounData;
        } else {
            data.push(pronounData);
        }
        let isSubField = false;
        props.onChange("speechSettingsFields,pronunciation", data,true);
        setEditIndex(null);
        handleBtnModal();
    };

    const pronounhandleChange = (e,field, type = "") => {
        let {name, value} = e.target;
        field.onChange(value);
        setPronounData((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));
    }

    const deleteProField = (rowData,rowIndex) =>{
        let data = speechSettingsRow?.["pronunciation"] || [];
        data = typeof data === "string" ? JSON.parse(data) : data;
        data?.splice(rowIndex, 1);
        props.onChange("speechSettingsFields,pronunciation", data,true);
    }

    const editProField = (data,rowIndex) =>{
        setPronounData((prevValues) => ({
            ...prevValues,
            "word": data?.["word"] ?? "",
            "alphabet" : data?.["alphabet"] ?? null,
            "phoneme" : data?.["phoneme"] ?? "",
        }));
        setEditIndex(rowIndex);
        handleBtnModal();
    }

    const openBtnModal = () =>{
        setPronounData((prevValues) => ({
            ...prevValues,
            "word": "",
            "alphabet" : null,
            "phoneme" :  "",
        }));
        handleBtnModal();
    }
    const togglePlayback = async(e,audioUrl) => {
        const newAudioState = await handleAudioOperation(audioUrl, audioStates);
        setAudioStates(newAudioState)
        if (newAudioState.audio) {
            newAudioState.audio.onended = () => {
                setAudioStates({isPlaying: false, audio: null });
            }
        }
    };
    const getVoiceDetails = (name,field,data) =>{
        return(
            voice && Object.keys(voice).length > 0 ? 
                <>
                    <InputGroup className='ms-1'>
                        <div className="border-voice input-group-text">
                            <audio-stream>
                                <a type='none' onClick={(e) => togglePlayback(e,voice?.['Audio'])} className='mt-1'>
                                    {audioStates['isPlaying'] ? <i class="apexcharts-legend-text fi fi-rr-pause"></i>  : <i class="voice-icon-color le-form-row fi fi-rr-play-circle"/>}
                                </a>
                            </audio-stream>
                        </div>
                        <div className="border-voice-img input-group-text cursor-pointer ps-1" onClick={openModel}>
                            {
                                !!voice?.['Icon'] ? 
                                <img
                                    className="voice-img-crop"
                                    src={voice?.['Icon']}
                                    alt=""
                                />:<i className="fi fi-ss-user-headset"></i>
                            }
                            <span className={`${!!voice?.['Icon'] ? "ps-2" : 'ps-2'} voice-name-span`}>{voice?.['Name'] ?? ''}</span>
                            <div className='pt-0 ps-2 pe-1 d-flex align-items-center  ms-auto'>
                                <div className='d-flex align-items-center voice-accent ps-2 pe-2'><>{voice?.['Accent']}</></div>
                            </div>
                            <div className=''>
                                <span><i className="d-flex align-items-center fi fi-rr-angle-small-down"></i></span>
                            </div>
                        </div>
                    </InputGroup>
                </> : <>
                <Input
                    {...field}
                    name={name}
                    type={'text'}
                    placeholder={'Please Choose a Voice'}
                    value={initialRowData['Voice'] ?? ""}
                    className={`${errors[name] ? 'is-invalid' : "cursor-pointer"}`}
                    onClick={e => openModel(e)}
                />
            </>
        )
    }

    const onHideSubSetting = (name) =>{
        if(!showSettingsMinFields.includes(name)){
            return
        };
        setCollapsed(prevValues => {
            const settingState = {};
            for (const key in prevValues) {
                settingState[key] = key === name ? !prevValues[key] : false;
            }
            return settingState;
          });
          
    }

    const constructInputBoxFields = (fields,rowFieldName,rowFields) =>{
        return(
            <>
                {fields && fields.map((field, index) => {
                    let { label, name, datalabel, type, placeholder, required, description, isDisabled, autoComplete, marks, min, max, step, options,value,subInFields,allowMulti,isClear} = field;
                    return(
                        <>
                            <Input
                                {...field}
                                type={type}
                                placeholder={placeholder}
                                value={name === "Voice" ? (voice ? voice.Name : '') : rowFields?.[datalabel] ?? value}
                                className={`${errors[name] ? 'is-invalid' : ""} ${["remainder_msg_frequency_seconds","remainder_msg_frequency_seconds_times"].includes(name) ? "w-25" : ''} text-center`}
                                onChange={e => handleChange(e,field,"",rowFieldName)}
                                onClick={name === "Voice" ? e => openModel(e) : undefined}
                                disabled={isDisabled}
                                autoComplete={autoComplete}
                            
                            />
                            <Label className='mt-2'> {label} </Label>
                        </>
                    )
                    
                })}
            </>
        );
    }
    const getOrderNumber = (orderNo) => {
        if (!orderNo) return 0;
        const numStr = orderNo.toString().replace(/\D/g, '');
        return numStr ? parseInt(numStr, 10) : 0;
      };
      
    const handlePhoneNumberDetailsChanges = (type, selectedOption) => {
        const field = type === 'incoming' ? 'incomingSelected' : 'outgoingSelected';
        setPhoneNumberDetails(prev => ({
            ...prev,
            [field]: selectedOption
        }));
    };

    const handleWebWigetDetailsChanges = (selectedOption)=>{
        setWebWidgetsMapping(selectedOption)
    }

    const hanleNewAgentConfiguration = () =>{
        return(
            <div className='agent-config-container'>
                <div className=''>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        {
                            (!isSubAccountView || (isSubAccountView && !showAgencySettingsHideFields.includes("agentInfoFields"))) && (
                                <div className='pb-5 agent-div-container agent-config-form hide'>
                                    <div className={`d-flex gap-2' ${showSettingsMinFields.includes("agentInfoFields") ? 'cursor-pointer' : ''}`} onClick = {e => onHideSubSetting("agentInfoFields")}>
                                        <span className={`mb-3 agent-header-title-main w-50 txt-ovrflw profile-headers-main`}>Agent Info</span>
                                        {
                                        showSettingsMinFields.includes("agentInfoFields") && 
                                            <div className='ms-auto gap-4'>
                                                <span className='split-setings-arrow custom-shadow'>{showTxt && (!isCollapsed["agentInfoFields"] ? 'more' : 'less')}
                                                    <span className=''>
                                                        <i className={`fi ${!isCollapsed["agentInfoFields"] ? 'adjust-position fi fi fi-bs-angle-double-small-down' : 'fi fi-br-angle-double-small-up '}`}></i>
                                                    </span>
                                                </span>
                                            </div>
                                        }    
                                    </div> 
                                    <Collapse isOpen={isCollapsed["agentInfoFields"]} >
                                        <Row className="mb-3">
                                            {filedsList && filedsList?.agentInfoFields?.map((field, index) => {
                                                const { label, name, datalabel, type, placeholder, required, description, isDisabled,autoComplete,marks,min,max,step,options,value } = field;
                                                return (
                                                    <Col md="4" lg="6" className='mb-3'>
                                                        <Label className="d-flex align-items-center label fv-normal" htmlFor={name}>
                                                            {label}
                                                            {false && 
                                                                description &&
                                                                <PopOverItem 
                                                                    id={index +"-agent"}
                                                                    body={description}
                                                                    theme={isDark}
                                                                />
                                                            }
                                                        </Label>
                                                        <Controller
                                                            name={name}
                                                            control={control}
                                                            rules={{
                                                                required:
                                                                required && ["text", "mension", "textarea"].includes(type) && !initialRowData[datalabel] 
                                                                    ? `${label} is required`
                                                                    : false,
                                                            }}
                                                            render={({ field }) => {
                                                                if (type !== "slider" && type !== "switch" && name !== 'Voice' && type !== 'dropdown') {
                                                                    return (
                                                                        <Input
                                                                            {...field}
                                                                            type={type}
                                                                            placeholder={placeholder}
                                                                            value={name === "Voice" ? (voice ? voice.Name : '') : initialRowData[datalabel] ?? ""}
                                                                            className={`${errors[name] ? 'is-invalid' : (name === "Call Start Message" ? "agent-greeting" : '')} ${name === "Voice" ? "cursor-pointer" : ''}`}
                                                                            onChange={e => handleChange(e,field)}
                                                                            onClick={name === "Voice" ? e => openModel(e) : undefined}
                                                                            disabled={isDisabled}
                                                                            autoComplete={autoComplete}
                                                                        />
                                                                    );
                                                                }else if (type === "slider") {
                                                                    return (
                                                                        sliderButton(name,min,max,marks,step,value,field)
                                                                    );
                                                                }else if (type === "switch") {
                                                                    return (
                                                                        switchButton(name,field)
                                                                    );
                                                                }else if(type==='dropdown'){
                                                                    return(
                                                                    <Select
                                                                        name={name}
                                                                        id={name}
                                                                        className="basic-select"
                                                                        classNamePrefix="sub-select wa-select"
                                                                        value={selectedOption?.[name] ? selectedOption[name] : options[0]}
                                                                        onChange={e => onSelectChange(name,e,field,options)}
                                                                        options={options}
                                                                    />
                                                                    )
                                                                }else if(name === 'Voice'){
                                                                    return(
                                                                        getVoiceDetails(name, field, initialRowData)
                                                                    )
                                                                }
                                                                return null; // Render nothing if type is neither "text" nor "slider"
                                                            }}
                                                        />
                                                        {errors[name] && (
                                                            <em className="text-danger">
                                                                {errors[name].message}
                                                            </em>
                                                        )}
                                                    </Col>
                                                );
                                            })}
                                        </Row>
                                    </Collapse>
                                </div>
                            )
                        }
                        { 
                            (!isSubAccountView || (isSubAccountView && !showAgencySettingsHideFields.includes("speechSettings"))) && (
                                <div className='pb-1 agent-div-container agent-config-form'>
                                    <div className={`d-flex gap-2' ${showSettingsMinFields.includes("speechSettings") ? 'cursor-pointer' : ''}`} onClick = {e => onHideSubSetting("speechSettings")}>
                                        <span className={`mb-3 agent-header-title-main w-50 txt-ovrflw profile-headers-main`}>Speech Settings</span>
                                        {
                                            showSettingsMinFields.includes("speechSettings") && 
                                                <div className='ms-auto gap-4'>
                                                    <span className='split-setings-arrow custom-shadow'>{ showTxt && (!isCollapsed["speechSettings"] ? 'more' : 'less')}
                                                        <span className=''>
                                                            <i className={`fi ${!isCollapsed["speechSettings"] ? 'adjust-position fi fi fi-bs-angle-double-small-down' : 'fi fi-br-angle-double-small-up '}`}></i>
                                                        </span>
                                                    </span>
                                                </div>
                                        }    
                                    </div>                           
                                    <Collapse isOpen={isCollapsed["speechSettings"]} >
                                        <Row className="mb-3">
                                            {allspeechSettingsFields && allspeechSettingsFields.sort((a,b) => getOrderNumber(a.orderNo) - getOrderNumber(b.orderNo))
                                                .map((field, index) => {
                                                const { label, name, datalabel, type, placeholder, required, description, isDisabled,autoComplete,marks,min,max,step,options,allowMulti,subFields,fields,value } = field;
                                                if(providerHideFields[providerName].includes(name)){
                                                    return;
                                                }
                                                return (
                                                    <Col md="6" lg="6" className='mb-3'>
                                                        <Label className="d-flex align-items-center label agent-header-title profile-headers" htmlFor={name}>
                                                            {label}
                                                            { 
                                                                description &&
                                                                <PopOverItem 
                                                                    id={index + "-speech"}
                                                                    body={description}
                                                                    theme={isDark}
                                                                />
                                                            }
                                                        </Label>
                                                        <Controller
                                                            name={name}
                                                            control={control}
                                                            rules={{
                                                                required:
                                                                required && ["text", "mension", "textarea"].includes(type)
                                                                && !speechSettingsRow[datalabel]
                                                                    ? `${label} is required`
                                                                    : false,
                                                            }}
                                                            render={({ field }) => {
                                                                if(type === "mention"){
                                                                    return(
                                                                        <div>
                                                                            <CratioMention
                                                                                name={name}
                                                                                inputID={name}
                                                                                value={speechSettingsRow[datalabel]}
                                                                                fieldkey="id"
                                                                                mentionTrigger="$"
                                                                                handleOnChange={handleOnChange}
                                                                                formname="table_74"
                                                                                control={control}
                                                                                customClassName="textbox-mention form-control"
                                                                                customPanelClassName="panel-mention-subject"
                                                                                placeholder="Enter email System Prompt Here"
                                                                                cols={66}
                                                                                suggestionList={selectedMacro}
                                                                                rows={20}
                                                                            />
                                                                            <p className='d-flex align-items-center form-label deploy-desc'>Note: Use '$' to add contact variables.</p>
                                                                        </div>
                                                                    )

                                                                }else if (type !== "slider" && type !== "switch" && type !== "dropdown" && type !== "buttonModal" && type !== 'subField' && type !== 'input_box') {
                                                                    return (
                                                                        <Input
                                                                            {...field}
                                                                            type={type}
                                                                            placeholder={placeholder}
                                                                            value={name === "Voice" ? (voice ? voice.Name : '') : speechSettingsRow[datalabel] ?? ""}
                                                                            className={`${errors[name] ? 'is-invalid' : (name === "Call Start Message" ? "agent-greeting" : '')} ${name === "Voice" ? "cursor-pointer" : ''}`}
                                                                            onChange={e => handleChange(e,field,"","speechSettingsFields")}
                                                                            onClick={name === "Voice" ? e => openModel(e) : undefined}
                                                                            disabled={isDisabled}
                                                                            autoComplete={autoComplete}
                                                                        />                                                                       
                                                                    );
                                                                }else if(type === "slider" ){
                                                                    return (
                                                                        sliderButton(name,marks,min,max,step,value,field,false,"speechSettingsFields",speechSettingsRow,true)
                                                                    );
                                                                }else if(type === "switch"){
                                                                    return (
                                                                        switchButton(name,field,"speechSettingsFields",speechSettingsRow)
                                                                    );
                                                                }else if (type === "dropdown"){
                                                                    return(
                                                                        <Select
                                                                            name={name}
                                                                            id={name}
                                                                            className="basic-select"
                                                                            classNamePrefix="sub-select wa-select"
                                                                            value={selectedOption?.[name] ? selectedOption[name] : options[0]}
                                                                            onChange={e => onSelectChange(name,e,field,options,"speechSettingsFields")}
                                                                            options={options}
                                                                            isMulti={allowMulti}
                                                                            styles={{
                                                                                dropdownIndicator: (base) => ({
                                                                                    ...base,
                                                                                    width: '30px',
                                                                                }),
                                                                            }}
                                                                        />
                                                                    )
                                                                }else if (type === "buttonModal") {
                                                                    let profieldsRaw = speechSettingsRow?.["pronunciation"] || [];
                                                                    let profields = typeof profieldsRaw === "string" ? parseJSON(profieldsRaw) : profieldsRaw;
                                                                    if (!Array.isArray(profields)) {
                                                                        profields = []; // fallback if it's not a valid array
                                                                    }
                                                                    return(
                                                                        <div>
                                                                            <div className='pb-2 '>
                                                                                {profields && profields.map((field, index) => (
                                                                                    <div key={index} className='agent-vmail-detect-bck-clr d-flex p-2 rounded-3 mb-2'>
                                                                                        <span>
                                                                                            <i class="fi fi-rs-comment cursor-pointer"></i>
                                                                                        </span>
                                                                                        <span className='ps-2 txt-ovrflw icon-color'>{field.word ?? field.pronoun_word}</span>
                                                                                        <span className='ms-auto gap-2 d-flex'>
                                                                                            <i class="fi fi-rc-pencil cursor-pointer" onClick={e => editProField(field,index)}></i>
                                                                                            <i className="fi fi-rr-trash cursor-pointer" onClick={e => deleteProField(field,index)}></i>
                                                                                        </span>
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                            <div>
                                                                                <Button onClick={e => openBtnModal()} className="d-flex gap-2 cursor-pointer agent-create-btn">
                                                                                    <i class="fi fi-br-plus"></i>
                                                                                    <span className="ms-auto">
                                                                                        Add
                                                                                    </span> 
                                                                                </Button>
                                                                            </div>
                                                                        </div>
                                                                        
                                                                    )
                                                                    
                                                                }else if( type === "input_box"){
                                                                    return(
                                                                        <div className='d-flex align-items-center fv-normal gap-2'>
                                                                            {constructInputBoxFields(fields,"speechSettingsFields",speechSettingsRow)}
                                                                        </div>                                                                       
                                                                    )
                                                                }

                                                                return null; // Render nothing if type is neither "text" nor "slider"
                                                            }}
                                                        />
                                                        {errors[name] && (
                                                            <em className="text-danger">
                                                                {errors[name].message}
                                                            </em>
                                                        )}
                                                        {(name === "transcription_mode" || name === "denoicing_mode" || (name === "backchanneling" && speechSettingsRow?.["backchanneling"])) && (
                                                            <div className={name === "backchanneling" ? 'flex flex-col rounded-lg p-4 agent-vmail-detect-bck-clr agent-vmail-detect-bck-rds' : ''}>
                                                                {constructSubFields(name, subFields,speechSettingsRow,"speechSettingsFields")}
                                                            </div>
                                                        )}
                                                    </Col>
                                                );
                                            })}
                                        </Row>
                                    </Collapse>           
                                </div>
                            )
                        }
                        {providerName === 'retell' &&
                            <div className='pb-1 agent-div-container agent-config-form'>
                            <div className={`d-flex gap-2' ${showSettingsMinFields.includes("transcriptionFields") ? 'cursor-pointer' : ''}`} onClick = {e => onHideSubSetting("transcriptionFields")}>
                                <span className={`mb-3 agent-header-title w-50 txt-ovrflw profile-headers-main`}>Transcription Settings</span>
                                {
                                    showSettingsMinFields.includes("transcriptionFields") && 
                                        <div className='ms-auto gap-4'>
                                            <span className='split-setings-arrow custom-shadow'>{ showTxt && (!isCollapsed["transcriptionFields"] ? 'more' : 'less')}
                                                <span className=''>
                                                    <i className={`fi ${!isCollapsed["transcriptionFields"] ? 'adjust-position fi fi fi-bs-angle-double-small-down' : 'fi fi-br-angle-double-small-up '}`}></i>
                                                </span>
                                            </span>
                                        </div>
                                }    
                            </div> 
                                <Collapse isOpen={isCollapsed["transcriptionFields"]} >
                                <Row className="mb-3">
                                    {transcriptionSettingsFields && transcriptionSettingsFields.sort((a,b) => getOrderNumber(a.orderNo) - getOrderNumber(b.orderNo))
                                        .map((field, index) => {
                                        const { label, name, datalabel, type, placeholder, required, description, isDisabled,autoComplete,subFields } = field;
                                        if(providerHideFields[providerName].includes(name)){
                                            return;
                                        }
                                        return (
                                            <Col md="6" lg="6" className='mb-3'>
                                                <Label className="d-flex align-items-center label" htmlFor={name}>
                                                    {label}
                                                    { 
                                                        description &&
                                                        <PopOverItem 
                                                            id={index + "-transcription"}
                                                            body={description}
                                                            theme={isDark}
                                                        />
                                                    }
                                                </Label>
                                                <Controller
                                                    name={name}
                                                    control={control}
                                                    rules={{
                                                        required:
                                                        required && ["text", "mension", "textarea"].includes(type)
                                                        && !speechSettingsRow[datalabel]
                                                            ? `${label} is required`
                                                            : false,
                                                    }}
                                                    render={({ field }) => {
                                                            if (type !== "slider" && type !== "switch" && type !== "dropdown" && type !== "buttonModal" && type !== 'subField' && type !== 'input_box') {
                                                            return (
                                                                <Input
                                                                    {...field}
                                                                    type={type}
                                                                    placeholder={placeholder}
                                                                    value={name === "Voice" ? (voice ? voice.Name : '') : speechSettingsRow[datalabel] ?? ""}
                                                                    className={`${errors[name] ? 'is-invalid' : (name === "Call Start Message" ? "agent-greeting" : '')} ${name === "Voice" ? "cursor-pointer" : ''}`}
                                                                    onChange={e => handleChange(e,field,"","speechSettingsFields")}
                                                                    onClick={name === "Voice" ? e => openModel(e) : undefined}
                                                                    disabled={isDisabled}
                                                                    autoComplete={autoComplete}
                                                                />                                                                       
                                                            );
                                                        }else if(type === "switch"){
                                                            return (
                                                                switchButton(name,field,"speechSettingsFields",speechSettingsRow)
                                                            );
                                                        }
                                                        return null;
                                                    }}
                                                />
                                                {errors[name] && (
                                                    <em className="text-danger">
                                                        {errors[name].message}
                                                    </em>
                                                )}
                                                {(name === "transcription_mode" || name === "denoicing_mode") && (
                                                    <div>
                                                        {constructSubFields(name, subFields,speechSettingsRow,"speechSettingsFields")}
                                                    </div>
                                                )}
                                            </Col>
                                        );
                                    })}
                                </Row>
                                </Collapse>
                            </div>
                        }
                        {
                            (!isSubAccountView || (isSubAccountView && !showAgencySettingsHideFields.includes("callSettings"))) && (
                                <div className='pb-1 agent-config-form agent-div-container'>
                                    <div className={`d-flex gap-2' ${showSettingsMinFields.includes("callSettings") ? 'cursor-pointer' : ''}`} onClick = {e => onHideSubSetting("callSettings")}>
                                        <span className={`mb-3 agent-header-title w-50 txt-ovrflw profile-headers-main`} >Call Settings</span>
                                        {
                                            showSettingsMinFields.includes("callSettings") && 
                                            <div className='ms-auto gap-4'>
                                                <span className='split-setings-arrow custom-shadow'>{showTxt && (!isCollapsed["callSettings"] ? 'more' : 'less')}
                                                    <span className=''>
                                                        <i className={`fi ${!isCollapsed["callSettings"] ? 'adjust-position fi fi fi-bs-angle-double-small-down' : 'fi fi-br-angle-double-small-up '}`}></i>
                                                    </span>
                                                </span>
                                            </div>
                                        }    
                                    </div>
                                    <Collapse isOpen={isCollapsed["callSettings"]} >
                                        <Row className="mb-3">
                                            {allCallSettingsFields && allCallSettingsFields?.sort((a,b) => getOrderNumber(a.orderNo) - getOrderNumber(b.orderNo))
                                                .map((field, index) => {
                                                const { label, name, datalabel, type, placeholder, required, description, isDisabled, autoComplete, marks, min, max, step, options,subFields,allowMulti,value } = field;
                                                if(providerName === 'vapi' && (name === 'transcription_model' || name === 'transcription_provider')){
                                                    if(name === 'transcription_model'){
                                                        callSettingsRow[datalabel] = callSettingsRow[datalabel] !== undefined && callSettingsRow[datalabel] !== null && callSettingsRow[datalabel] !== '' ? callSettingsRow[datalabel] : 'nova-2-phonecall';
                                                    }else{
                                                        callSettingsRow[datalabel] = callSettingsRow[datalabel] !== undefined && callSettingsRow[datalabel] !== null && callSettingsRow[datalabel] !== '' ? callSettingsRow[datalabel] : 'deepgram';
                                                    }
                                                }
                                                if(providerName == "retell" && ["idle_message"].includes(name)){
                                                    return;
                                                }
                                                return (                                    
                                                    <Col md="6" lg="6" className='mb-3'>
                                                        <Label className="d-flex align-items-center label fv-normal" htmlFor={name}>
                                                            {label}
                                                            { 
                                                                description &&
                                                                <PopOverItem 
                                                                    id={index + "-call_settings_call"}
                                                                    body={description}
                                                                    theme={isDark}
                                                                />
                                                            }
                                                        </Label>
                                                        <Controller
                                                            name={name}
                                                            control={control}
                                                            rules={{
                                                                required:
                                                                required && ["text", "mension", "textarea"].includes(type)
                                                                    ? `${label} is required`
                                                                    : undefined,
                                                            }}
                                                            render={({ field }) => {
                                                                if (type !== "slider" && type !== "switch" && type !== "dropdown") {
                                                                    return (
                                                                        <Input
                                                                            {...field}
                                                                            type={type}
                                                                            placeholder={placeholder}
                                                                            value={name === "Voice" ? (voice ? voice.Name : '') : callSettingsRow[datalabel] ?? ""}
                                                                            className={`${errors[name] ? 'is-invalid' : (name === "Call Start Message" ? "agent-greeting" : '')} ${name === "Voice" ? "cursor-pointer" : ''}`}
                                                                            onChange={e => handleChange(e,field,"","callSettingsFields")}
                                                                            onClick={name === "Voice" ? e => openModel(e) : undefined}
                                                                            disabled={isDisabled}
                                                                            autoComplete={autoComplete}
                                                                        />
                                                                    );
                                                                }else if (type === "slider") {
                                                                    return (
                                                                        sliderButton(name,marks,min,max,step,value,field,true,"callSettingsFields",callSettingsRow)
                                                                    );
                                                                }else if(type === "switch"){
                                                                    return (
                                                                        switchButton(name,field,"callSettingsFields",callSettingsRow)
                                                                    );
                                                                }else if (type === "dropdown"){
                                                                    return(
                                                                        <>
                                                                            <Select
                                                                                name="selected_form"
                                                                                id="selected_form"
                                                                                className="basic-select"
                                                                                classNamePrefix="sub-select wa-select"
                                                                                value={selectedOption?.[name] ? selectedOption[name] : options[0]}
                                                                                onChange={e => onSelectChange(name,e,field,options,"callSettingsFields")}
                                                                                options={options}
                                                                                isMulti={allowMulti}
                                                                                isClearable={true}
                                                                                filterOption={customFilter}
                                                                            />
                                                                        </>
                                                                    )
                                                                }
                                                                return null; // Render nothing if type is neither "text" nor "slider"
                                                            }}
                                                        />
                                                        {errors[name] && (
                                                            <em className="text-danger">
                                                                {errors[name].message}
                                                            </em>
                                                        )}
                                                        {((name === "voicemail_detection" && callSettingsRow["voicemail_detection"])  || (name === "user_input_key_detection" && callSettingsRow["user_input_key_detection"])) && (
                                                            <div className='flex flex-col rounded-lg p-4 agent-vmail-detect-bck-clr agent-vmail-detect-bck-rds'>
                                                                {constructSubFields(name,subFields,callSettingsRow,"callSettingsFields")}
                                                            </div>
                                                        )}
                                                    </Col>
                                                );
                                            })}
                                        </Row>
                                    </Collapse>
                                </div>
                            )
                        }
                        {
                            ((isAgencyView && isSubAccountView && !showAgencySettingsHideFields.includes("agentSettings"))) && (
                                <div className='pb-1 agent-config-form'>
                                    <div className={`d-flex gap-2' ${showSettingsMinFields.includes("agentSettings") ? 'cursor-pointer' : ''}`} onClick = {e => onHideSubSetting("agentSettings")}>
                                        <span className={`mb-3 agent-header-title w-50 txt-ovrflw profile-headers-main`} >Agency Settings</span>
                                        {
                                            showSettingsMinFields.includes("agentSettings") && 
                                                <div className='ms-auto gap-4'>
                                                    <span className='split-setings-arrow custom-shadow'>{showTxt && (!isCollapsed["agentSettings"] ? 'more' : 'less')}
                                                        <span className=''>
                                                            <i className={`fi ${!isCollapsed["agentSettings"] ? 'adjust-position fi fi fi-bs-angle-double-small-down' : 'fi fi-br-angle-double-small-up '}`}></i>
                                                        </span>
                                                    </span>
                                                </div>
                                        }    
                                    </div>
                                    <Collapse isOpen={isCollapsed["agentSettings"]} >
                                        <Row className="mb-3">
                                            {filedsList?.agentSettingsFields?.[providerName]?.map((field, index) => {
                                                const { label, name, datalabel, type, placeholder, required, description, isDisabled, autoComplete, marks, min, max, step, options,subFields,allowMulti ,value} = field;
                                                return (                                    
                                                    <Col md="6" lg="6" className='mb-3'>
                                                        <Label className="d-flex align-items-center label fv-normal" htmlFor={name}>
                                                            {label}
                                                            { 
                                                                description &&
                                                                <PopOverItem 
                                                                    id={index + "-agency_call"}
                                                                    body={description}
                                                                    theme={isDark}
                                                                />
                                                            }
                                                        </Label>
                                                        <Controller
                                                            name={name}
                                                            control={control}
                                                            rules={{
                                                                required:
                                                                required && ["text", "mension", "textarea"].includes(type)
                                                                    ? `${label} is required`
                                                                    : undefined,
                                                            }}
                                                            render={({ field }) => {
                                                                if (type !== "slider" && type !== "switch" && type !== "dropdown") {
                                                                    return (
                                                                        <Input
                                                                            {...field}
                                                                            type={type}
                                                                            placeholder={placeholder}
                                                                            value={name === "Voice" ? (voice ? voice.Name : '') : agencySettingsRow[datalabel] ?? ""}
                                                                            className={`${errors[name] ? 'is-invalid' : (name === "Call Start Message" ? "agent-greeting" : '')} ${name === "Voice" ? "cursor-pointer" : ''}`}
                                                                            onChange={e => handleChange(e,field,"","agencySettingsFields")}
                                                                            onClick={name === "Voice" ? e => openModel(e) : undefined}
                                                                            disabled={isDisabled}
                                                                            autoComplete={autoComplete}
                                                                        />
                                                                    );
                                                                }else if (type === "slider") {
                                                                    return (
                                                                        sliderButton(name,marks,min,max,step,value,field,true,"agencySettingsFields",agencySettingsRow)
                                                                    );
                                                                }else if(type === "switch"){
                                                                    return (
                                                                        switchButton(name,field,"agencySettingsFields",agencySettingsRow)
                                                                    );
                                                                }else if (type === "dropdown"){
                                                                    return(
                                                                        <>
                                                                            <Select
                                                                                name="selected_form"
                                                                                id="selected_form"
                                                                                className="basic-select"
                                                                                classNamePrefix="sub-select wa-select"
                                                                                value={selectedOption?.[name] ? selectedOption[name] : ""}
                                                                                onChange={e => onSelectChange(name,e,field,options,"agencySettingsFields")}
                                                                                options={options}
                                                                                isMulti={allowMulti}
                                                                                isClearable={true}
                                                                                filterOption={customFilter}
                                                                                isDisabled={isDisabled}
                                                                            />
                                                                        </>
                                                                    )
                                                                }
                                                                return null; // Render nothing if type is neither "text" nor "slider"
                                                            }}
                                                        />
                                                        {errors[name] && (
                                                            <em className="text-danger">
                                                                {errors[name].message}
                                                            </em>
                                                        )}
                                                    </Col>
                                                );
                                            })}
                                        </Row>
                                    </Collapse>
                                </div> 
                            )
                        }
                                                    
                        {isAllowEdit &&
                            <Row className='agent-config-form mb-5 '>
                                <Col md="2">
                                <Loading 
                                    showLoader={isLoading} 
                                    mainContent = {
                                        <Button className="mb-2 btn-icon submit-btn btn-background hide" type="submit">
                                            Save
                                        </Button>
                                    }
                                />
                                </Col>
                            </Row>
                        }
                    </Form>
                    {isBtnModal && getBtnModal()}
                </div>
            </div>
        );
            
    }

    const getProfileData = () =>{
        return(
            <Container fluid className='p-0'>
                {allowNewConfig ? (
                    hanleNewAgentConfiguration()
                ) : (
                    <div className='agent-config-container'>
                        <div className='agent-config-form'>
                            <Form onSubmit={handleSubmit(onSubmit)}>
                            {
                                filedsList?.configViewFieldSave?.map(({ label, name, datalabel, type, placeholder, required, description, isDisabled, autoComplete }, index) => 
                                !isAllowVoiceField ? null : (
                                    <Row key={index} className="mb-3">
                                        <Col md="12" lg="12">
                                            <Label className="d-flex align-items-center fv-normal label" htmlFor={name}>
                                                {label}
                                                {false && description && <PopOverItem id={index + "-config"} body={description} theme={isDark} />}
                                            </Label>
                                            <Controller
                                                name={name}
                                                control={control}
                                                rules={{
                                                    required:
                                                      required &&
                                                      ["text", "mension", "textarea"].includes(type) && !initialRowData[datalabel]
                                                      ? `${label} is required`
                                                      : false,
                                                  }}
                                                render={({ field }) => (
                                                    <Input
                                                        {...field}
                                                        type={type}
                                                        placeholder={placeholder}
                                                        value={name === "Voice" ? (voice?.Name || '') : initialRowData[datalabel]}
                                                        className={`${errors[name] ? 'is-invalid' : (name === "Call Start Message" ? "agent-greeting" : '')} ${name === "Voice" ? "cursor-pointer" : ''}`}
                                                        onChange={handleChange}
                                                        onClick={name === "Voice" ? openModel : undefined}
                                                        disabled={isDisabled}
                                                        autoComplete={autoComplete}
                                                    />
                                                )}
                                            />
                                            {errors[name] && <em className="text-danger">{errors[name].message}</em>}
                                        </Col>
                                    </Row>
                                ))
                            }
    
                            {isAdmin && isAllowEdit &&
                                <Row>
                                    <div className='col-2 '>
                                    <Loading 
                                        showLoader={isLoading} 
                                        mainContent = {
                                            <Button className="agent-save-btn mb-2 btn-icon submit-btn btn-background hide" type="submit">
                                                Save
                                            </Button>}
                                    />
                                    </div>
                                </Row>
                            }
                            </Form>
                        </div>
                    </div>
                )}
            </Container>
        );
    };

    const advancedSettings = () => {   
        let adv_set = initialRowData?.["advanced settings"] != undefined ? parseJSON(initialRowData["advanced settings"]) : []; 
        return (
            <Fragment>
                <Form className="m-4" onSubmit={(e) => {
                        e.preventDefault();
                        handleSubmit((data) => props.onSubmit(data, "adv_set"))(e); // Call the function properly
                    }
                }>
                    {
                        filedsList?.advancedSettingsFields && filedsList?.advancedSettingsFields?.map((field) => {
                            const { label, name, type, placeholder, description, isDisabled, autoComplete } = field;
                            return(
                                <FormGroup>
                                    <Label for={name} className="agent-header-title">{label}</Label>
                                    <p>{description}</p>
                                    <Controller
                                        name={name}
                                        control={control}
                                        rules={{ required: false}}//!adv_set[name] || adv_set[name] === "" ? `${label} is required` : false }}
                                        render={({ field }) => (
                                            <>
                                                <InputGroup>
                                                    <Input
                                                        {...field}
                                                        type={showSecret && name === "secret" ? "password" : type}
                                                        placeholder={placeholder}
                                                        value={adv_set[name] ?? ""}
                                                        className={`${errors[name] ? 'is-invalid' : ''}`}
                                                        onChange={e => {handleChange(e, field,"adv_settings")}}
                                                        disabled={isDisabled}
                                                        autoComplete= {autoComplete}
                                                    />
                                                    {
                                                        name === "secret" && 
                                                            <div className={"input-group-text cursor-pointer"} onClick={ e => setShowSecret(!showSecret)}>
                                                            {
                                                                showSecret ? (
                                                                    <i class="fi fi-rr-eye-crossed"></i>
                                                                ) : (
                                                                    <i class="fi fi-rr-eye"></i>
                                                                )
                                                            }
                                                        </div>
                                                    }
                                                </InputGroup>
                                            </>
                                        )}
                                    />
                                    {errors[name] && <em className={`error invalid-feedback`}>{errors[name].message}</em>}
                                </FormGroup>
                            )
                        })
                    }
                    <FormGroup>
                        <Button className="theme-bg-g ms-auto" type="submit">
                            Save
                        </Button>
                    </FormGroup>
                </Form>
            </Fragment>
        )
    }
    const infoTab = () =>{
        
        return(
            <div className='agent-config-container'>
                <div className=''>
                    <Form onSubmit={handleSubmit(onSubmit)}> 
                        {
                            <div className='pb-1 agent-div-container agent-config-form'>
                                <Row>
                                    <div className='d-flex align-items-center'>
                                        <Col>
                                        <div className={`d-flex gap-2' ${showSettingsMinFields.includes("agentInfoFields") ? 'cursor-pointer' : ''} mb-2`} onClick = {e => onHideSubSetting("agentInfoFields")}>
                                            <span className={`mb-3 pt-3 agent-header-title w-50 txt-ovrflw profile-headers-main`}>Agent Info</span>
                                        </div> 
                                        </Col>
                                        <Col className="d-flex justify-content-end">
                                        <div className='mb-2'>
                                            <button type="button" className={cx("btn btn-list theme-bg-g d-flex", {"disabled": isCallReady,},{"disabled": isCallLoading})}    onClick={e => props.handleDropDownChange("webcall")}><i class="fi fi-rr-phone-call pr-1"></i>Talk to AI Agent</button>
                                        </div>
                                        </Col>
                                    </div>
                                </Row>
                                <Row className="mb-3">
                                    {filedsList && filedsList?.agentInfoFields?.map((field, index) => {
                                        const { label, name, datalabel, type, placeholder, required, description, isDisabled,autoComplete,marks,min,max,step,options,allowMulti } = field;
                                        if(name === "knowledgebase" && !showAgentKnowledgeBase && !isAgencyView){
                                            return;
                                        }
                                        return (
                                            <Col md="4" lg="6" className='mb-3'>
                                                <Label className="d-flex align-items-center  label fv-normal" htmlFor={name}>
                                                    {label}
                                                    {false && 
                                                        description &&
                                                        <PopOverItem 
                                                            id={index +"-agent"}
                                                            body={description}
                                                            theme={isDark}
                                                        />
                                                    }
                                                </Label>
                                                <Controller
                                                    name={name}
                                                    control={control}
                                                    rules={{
                                                        required:
                                                        required && ["text", "mension", "textarea"].includes(type)
                                                            ? `${label} is required`
                                                            : undefined,
                                                    }}
                                                    render={({ field }) => {
                                                        if (type !== "slider" && type !== "switch" && name !== 'Voice' && type !== 'dropdown') {
                                                            return (
                                                                <Input
                                                                    {...field}
                                                                    type={type}
                                                                    placeholder={placeholder}
                                                                    value={name === "Voice" ? (voice ? voice.Name : '') : initialRowData[datalabel] ?? ""}
                                                                    className={`${errors[name] ? 'is-invalid' : (name === "Call Start Message" ? "agent-greeting" : '')} ${name === "Voice" ? "cursor-pointer" : ''}`}
                                                                    onChange={e => handleChange(e,field)}
                                                                    onClick={name === "Voice" ? e => openModel(e) : undefined}
                                                                    disabled={isDisabled}
                                                                    autoComplete={autoComplete}
                                                                />
                                                            );
                                                        }else if (type === "slider") {
                                                            return (
                                                                sliderButton(name,min,max,step,marks,field)
                                                            );
                                                        }else if (type === "switch") {
                                                            return (
                                                                switchButton(name,field)
                                                            );
                                                        }else if(type==='dropdown'){
                                                            return(
                                                            <Select
                                                                name={name}
                                                                id={name}
                                                                className="basic-select"
                                                                classNamePrefix="sub-select wa-select"
                                                                value={selectedOption?.[name] ? selectedOption[name] : name !== "knowledgebase" ? options[0] : ""}
                                                                onChange={e => onSelectChange(name,e,field,options)}
                                                                options={options}
                                                                isMulti={allowMulti}
                                                            />
                                                            )
                                                        }else if(name === 'Voice'){
                                                            return(
                                                                getVoiceDetails(name,field,initialRowData)
                                                            )
                                                        }
                                                        return null; // Render nothing if type is neither "text" nor "slider"
                                                    }}
                                                />
                                                {errors[name] && (
                                                    <em className="text-danger">
                                                        {errors[name].message}
                                                    </em>
                                                )}
                                            </Col>
                                        );
                                    })}
                                </Row>
                            </div>
                        }
                        {
                            <div className='pb-1 agent-div-container agent-config-form hide'>
                                <Row>
                                    {filedsList.callMappings.map(({ type, label }) => (
                                        <Col md={6} className='mb-3' key={type}>
                                            <div className='d-flex gap-2'>
                                                <span className='mb-3 agent-header-title fv-normal'>{label}</span>
                                            </div>
                                            <IOMapping
                                                type={type}
                                                handleOnChange={handlePhoneNumberDetailsChanges}
                                                defaultId={initialRowData?.["table_250_id"]}
                                            />
                                        </Col>
                                    ))}
                                </Row>
                            </div>
                        }
                        {
                            <div className='pb-1 agent-div-container agent-config-form hide'>
                                <div className={`d-flex gap-2' ${showSettingsMinFields.includes("agentInfoFields") ? 'cursor-pointer' : ''}`} onClick = {e => onHideSubSetting("agentInfoFields")}>
                                    <span className={`mb-3 agent-header-title w-50 txt-ovrflw fv-normal`}>Web Widgets</span>
                                </div>
                                <WebWidgetsMapping  handleOnChange = {handleWebWigetDetailsChanges} defaultId ={initialRowData?.["table_250_id"]}/>
                            </div>
                        }
                        {isAllowEdit &&
                            <Row className='agent-config-form mb-5'>
                                <Col md="2">
                                <Loading 
                                    showLoader={isLoading} 
                                    mainContent = {
                                        <Button className="mb-2 btn-icon submit-btn btn-background hide" type="submit">
                                            Save
                                        </Button>
                                    }
                                />
                                </Col>
                            </Row>
                        }
                    </Form>
                </div>
            </div>
        );
            
    }
    const subtables = [
        {
            name :"Basic",
            component:<Fragment>{infoTab()}</Fragment>
        },
        ...(showAgentProfileSettings || isAgencyView ? [{
            name: "Settings",
            component: <Fragment>{getProfileData()}</Fragment>
        }] : []),
        ...(showAgentRoleSettings || isAgencyView ? [{
            name: "Prompt",
            component: <Fragment> {roleTab()} </Fragment>
        }] : []),
        ...(showAgentActionSettings || isAgencyView ? [{
            name: "Actions",
            component: <AgentActions
                agentID={initialRowData['Agent ID']}
                agentDetails={initialRowData}
                onChange={props.onChange}
                onSubmit={props.onSubmit}
                resetToAgentDetail={resetToAgentDetail}
            />
        }] : []),
        ...(showAgentDeploy || isAgencyView ? [{
            name:"Deploy",
            component: <Fragment> {deployTab()} </Fragment>
        }]:[])
        // {
        //     name: "Advanced",
        //     component: <Fragment>{advancedSettings()}</Fragment>,
        // },        
    ];
    /*if(showAgentActionSettings){
        subtables.push({
            name: "Action",
            component: <AgentActions 
                agentID={initialRowData['Agent ID']} 
                agentDetails={initialRowData} 
                onChange={props.onChange}
                onSubmit={props.onSubmit}
                resetToAgentDetail={resetToAgentDetail}
            />
        })
    };*/
    /* if(webhooksEnabled){
        subtables.push({
            name: "Advanced",
            component: <Fragment>{advancedSettings()}</Fragment>,
        })
    }; */


    const getSimpleTabs = () => {
        return subtables.map(({ name, component }, index) => ({
            key: index,
            title: name,
            getContent: () => component,
        }));
    }
   
    return (
        <Fragment>
            <div className={'agent-details calls-details p-0 w-100 ' + (isMobile() ? "position-fixed" : "")}>
                <Row>
                    <Col md="12">
                        <Tabs 
                            tabsWrapperClass="body-tabs" 
                            activeTab={"1"}
                            showMore={true}
                            transform={true}
                            showInkBar={true}
                            selectedTabKey={0}
                            transformWidth={400}
                            items={getSimpleTabs()} />
                    </Col>
                </Row>
            </div>
        </Fragment>
    );
});




const mapStateToProps = state => ({
    appCustomTitle: state.ThemeOptions.appCustomTitle
});

const mapDispatchToProps = dispatch => ({
    setAppCustomTitle: title => dispatch(setAppCustomTitle(title)),
});

export default AgentMainContent;